// extracted by mini-css-extract-plugin
export default {"large":"ald_icons__large__hpbwI","mediumSquare":"ald_icons__mediumSquare__m3pUk","darkIcon":"ald_icons__darkIcon__X42pX","whiteIcon":"ald_icons__whiteIcon__zrcp8"};